import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  Spinner,
  Image,
  Loading,
  Button,
  DataTable,
  ButtonGroup,
  Toast,
  Checkbox,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
  PageActions,
  Link,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import Select2 from "react-select";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

const AddLectureSubscriber = () => {
  const { id, lectureId } = useParams(); // id = courseId, lectureId = lectureId
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const [optionsUsers, setOptionsUsers] = useState([]);
  const [user, setUser] = useState("");
  const handleSelectChangeUser = (newValue) => {
    setUser(newValue);
    setUserError("");
  };
  const [userError, setUserError] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    let responseUsers = [];
    try {
      responseUsers = await axios.get(`/users?per_page=10000`);
      setOptionsUsers(
        responseUsers.data.data.data.map((item, index) => {
          return {
            label: item?.name,
            value: String(item.id),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <Page
      title="Add User to Lecture"
      narrowWidth
      backAction={{
        onAction: () => navigate(`/admin/courses/${id}/lectures/${lectureId}/subscribers`),
      }}
    >
      <Card>
        {isSaving ? <Loading /> : null}

        <FormLayout>
          <Text>User</Text>
          <Select2
            options={optionsUsers}
            onChange={handleSelectChangeUser}
            value={user}
            placeholder="Please select a user"
            styles={{
              menu: (provided) => ({
                ...provided,
                maxHeight: "170px",
                overflowY: "auto",
              }),
              menuList: (provided) => ({
                ...provided,
                maxHeight: "170px",
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            menuPosition="absolute"
          />
          <InlineError message={userError} />
          <div style={{ height: "200px" }}></div>
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={
          <Button variant="primary" onClick={handleSave}>
            {isSaving ? <Spinner size="small" /> : "Save"}
          </Button>
        }
      />
    </Page>
  );

function handleSave() {
  if (user === "") {
    setUserError("Please select a user");
  } else {
    console.log('=== DEBUG INFO ===');
    console.log('Course ID (id):', id);
    console.log('Lecture ID (lectureId):', lectureId);
    console.log('Selected user object:', user);
    console.log('User ID being sent:', user.value);
    console.log('User ID type:', typeof user.value);
    console.log('Request URL will be:', `/orders/lectures/${lectureId}`);
    console.log('Request payload:', { user_id: user.value });
    
    setIsSaving(true);
    axios
      .post(`/orders/lectures/${lectureId}`, { user_id: user.value })
      .then((result) => {
        console.log('Success:', result);
        navigate(`/admin/courses/${id}/lectures/${lectureId}/subscribers`);
      })
      .catch((err) => {
        console.error('=== ERROR DETAILS ===');
        console.error('Error response:', err.response);
        console.error('Error data:', err.response?.data);
        console.error('Error status:', err.response?.status);
        console.error('Error message:', err.response?.data?.message);
        console.error('Validation errors:', err.response?.data?.errors);
        setIsSaving(false);
      });
  }
}
};

export default AddLectureSubscriber;